import angular from 'angular';
import 'angular-route';
import 'angular-modal-service';
import './util/uploader'
require('textangular/dist/textAngular-sanitize.min');
// import 'textangular';

// angular modules
import onConfig  from './on_config';
import onRun     from './on_run';
import './templates';
import './angular/controllers';
import './angular/services';
import './angular/components';

// create and bootstrap application
const requires = [ 'ngRoute', // 'textAngular',
  'templates', 'angularModalService', 'app.controllers', 'app.services', 'app.components', 'ui.uploader' ];

// mount on window for testing
window.app = angular.module('app', requires);
angular.module('app').config(onConfig);
angular.module('app').run(onRun);

angular.module('app').filter('trust', [ '$sce', function ($sce) {
  return function (input) {
    return $sce.trustAsHtml(input);
  }
} ]);

angular.bootstrap(document, [ 'app' ], {
  // strictDi: true
});
